import { SideNavbarTranslate } from './sidenavbarTranslate.model';

const sidenavbarTranslatePTBR: SideNavbarTranslate = {
  tooltip: {
    openSidebar: 'Abrir barra lateral',
    closeSidebar: 'Fechar barra lateral',
  },
  theme: {
    light: 'Tema claro',
    dark: 'Tema escuro',
    system: 'Tema do sistema',
  },
  header: {
    organizations: 'Organizações',
    greeting: 'Olá, {{name}}',
    userMenu: 'Abrir menu da conta',
  },
  groups: {
    analytics: 'Análises',
    management: 'Gerenciar',
  },
  body: {
    home: 'Início',
    leads: 'Clientes',
    events: 'Eventos',
    todos: 'Tarefas',
    catalog: 'Catálogo',
    contracts: 'Contratos',
    billing: 'Assinatura',
    team: 'Equipe',
    statistics: 'Estatísticas',
    reports: 'Relatórios',
  },
  footer: {
    settings: 'Configurações',
    logout: 'Sair',
  },
  actions: {
    closeModal: 'Fechar',
    closeMenu: 'Fechar menu',
    add: 'Adicionar',
  },
};

export default sidenavbarTranslatePTBR;
